package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.cash_register_configuration.tabs.devices.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.devices.CafeModeEnum
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.jetbrains.compose.web.dom.Text

@Composable
fun VatConfigContent(
    normalVat: Double?,
    reducedVat: Double?,
    specialVat: Double?,
    isItCafeMode: Int?,
    updateData:(String,dynamic)->Unit
)
{

    Column(
        modifier = Modifier
            .margin(top = Dimen.normalPadding)
    )
    {
        MediumContentTitle(
            modifier = Modifier  ,
            title = Strings.current().vat,
            marginBottom = Dimen.mediumPadding,
            marginTop = Dimen.semiLargePadding,
        )


        CustomEditText(
            label = Strings.current().normalVat,
            isDecimal = true,
            value = normalVat?.toString() ?: "",
            marginBottom = Dimen.normalPadding,
            width = Dimen.semiMediumEditTextWidth,
            isOutlinedEditText = true,
            textAlign = TextAlign.End,
            isRequired = false,
            hint = "",
            onFocusIn = {},
            onFocusOut = {
                 updateData(ApiUtils.Field.normalVat,it.toDouble())
            },
            onInputChange = {newValue, validation ->

            },
        )
        CustomEditText(
            isDecimal = true,
            width = Dimen.semiMediumEditTextWidth,
            label = Strings.current().reducedVat,
            value = reducedVat?.toString()?:"",
            isOutlinedEditText = true,
            marginBottom = Dimen.normalPadding,
            textAlign = TextAlign.End,
            isRequired = false,
            hint = "",
            onFocusIn = {},
            onFocusOut = {
                updateData(ApiUtils.Field.reducedVat,it.toDouble())
            },
            onInputChange = {it, validation ->

            },
        )
        CustomEditText(
            isDecimal = true,
            label = Strings.current().specialVat,
            value = specialVat?.toString()?:"",
            isOutlinedEditText = true,
            width = Dimen.semiMediumEditTextWidth,
            marginBottom = Dimen.normalPadding,
            textAlign = TextAlign.End,
            isRequired = false,
            hint ="",
            onFocusIn = {},
            onFocusOut = {
                updateData(ApiUtils.Field.specialVat,it.toDouble())
            },
            onInputChange = {it, validation ->

            },
        )



        DropDownItem(
            modifier = Modifier,
            itemWidth = Dimen.semiMediumEditTextWidth,
            options = CafeModeEnum.entries,
            label = Strings.current().inTheHouse,
            selectedItem = CafeModeEnum.entries.find {
                it.value == isItCafeMode
            },
            displayText = { item ->
                if (item is CafeModeEnum) item.title else ""
            },
            onOptionClick = {
                if (it is CafeModeEnum){
                    updateData(ApiUtils.Field.isInCafeModeInt,it.value)
                }
            }
        )




    }

}